import {
  CHANGE_CURRENCY,
  CLOSE_LOCATION,
  CLOSE_SELECT, FETCH_BANKS_ERROR,
  FETCH_BANKS_PENDING,
  FETCH_BANKS_SUCCESS, FETCH_BRANCHES_PENDING, FETCH_BRANCHES_SUCCESS, LOCATION_TRANSLATE,
  OPEN_LOCATION,
  OPEN_SELECT,
  SELECT_CURRENCY,
  SELECT_DATE,
  SELECT_LOCATION,
  SORT_ASC_BUY,
  SORT_ASC_SELL,
  SORT_DESC_BUY,
  SORT_DESC_SELL
} from '../utils/action-types';

const handlers = {
  DEFAULT: state => state,
  [OPEN_SELECT]: state => ({...state, open: true}),
  [CLOSE_SELECT]: state => ({...state, open: false}),
  [OPEN_LOCATION]: state => ({...state, open_location_select: true}),
  [CLOSE_LOCATION]: state => ({...state, open_location_select: false}),
  [CHANGE_CURRENCY]: (state, {payload}) => ({
    ...state,
    open: false,
    radio: payload.value,
    value: payload
  }),
  [SELECT_CURRENCY]: (state, {payload}) => ({
    ...state,
    open: false,
    radio: 'all',
    value: payload
  }),
  [SELECT_LOCATION]: (state, {payload}) => ({
    ...state,
    open_location_select: false,
    selectedLocation: payload
  }),
  [SELECT_DATE]: (state, {payload}) => ({
    ...state,
    date: payload
  }),
  [SORT_ASC_SELL]: state => ({
    ...state,
    data: state.data.sort((a, b) => a.sell - b.sell),
    sorted: 'sell_asc'
  }),
  [SORT_DESC_SELL]: state => ({
    ...state,
    data: state.data.sort((a, b) => b.sell - a.sell),
    sorted: 'sell_desc'
  }),
  [SORT_ASC_BUY]: state => ({
    ...state,
    data: state.data.sort((a, b) => a.buy - b.buy),
    sorted: 'buy_asc'
  }),
  [SORT_DESC_BUY]: state => ({
    ...state,
    data: state.data.sort((a, b) => b.buy - a.buy),
    sorted: 'buy_desc'
  }),
  [FETCH_BANKS_PENDING]: (state, {payload}) => ({
    ...state,
    data: payload,
    isFetching: true,
    isError: false
  }),
  [FETCH_BANKS_SUCCESS]: (state, {payload}) => ({
    ...state,
    data: payload,
    lastModified: Math.max(...payload.map(e => new Date(e.lastReceivedRatesTime))),
    isFetching: false,
    isError: false
  }),
  [FETCH_BANKS_ERROR]: (state, {payload}) => ({
    ...state,
    data: payload,
    isFetching: false,
    isError: true
  }),
  [FETCH_BRANCHES_PENDING]: state => ({
    ...state,
    isFetching: true,
    isError: false
  }),
  [FETCH_BRANCHES_SUCCESS]: (state, {payload}) => ({
    ...state,
    savedBranches: [...state.savedBranches, payload],
    isFetching: false,
    isError: false
  }),
  [LOCATION_TRANSLATE]: (state, {payload}) => ({
    ...state,
    locationTranslate: payload
  })
};

export const banksReducer = (state, action) => {
  const handler = handlers[action.type] || handlers.DEFAULT;

  return handler(state, action);
};
